import { FC, useEffect, useState } from "react";
import CN from "classnames";
import Logo from "../../assets/images/logo.svg";
import { Button } from "../../components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAppDispatch } from "../../hooks/store.hooks";
import { login } from "../../store/reducers/auth/authSlice";
import { LoginUser } from "../../store/reducers/auth/loginUser.interface";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { OtpVerification } from "./Component/OtpVerification";
import { SubmitHandler, useForm } from "react-hook-form";

export interface LoginProps {
  [x: string]: any;
}

export const Login: FC<LoginProps> = ({
  className,
  ...restProps
}: LoginProps) => {
  const LoginClasses = CN("login overflow-hidden", className);

  const { isLoading, errorMsg, otpData } = useSelector(
    (state: any) => state.rootReducer.auth
  );

  const [credentials, setCredentials] = useState<LoginUser | null>(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useAppDispatch();

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(40, "Password must not exceed 40 characters"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<LoginUser>({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit: SubmitHandler<LoginUser> = async (data: any) => {
    const loginUserAndClintToken: LoginUser = data;
    const loginUser = {
      email: loginUserAndClintToken.email,
      password: loginUserAndClintToken.password,
      // clientToken: localStorage.getItem('client'),
    };
 setCredentials(loginUser);
    await dispatch(login(loginUser));
  };

  // useEffect(() => {
  //   console.log(otpData);
  // }, [otpData]);

  return (
    <motion.div
      className={LoginClasses}
      {...restProps}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="flex h-screen items-center justify-center bg-darkBg">
        {!otpData?.otpSended ? (
          <form
            className="flex flex-col w-full max-w-lg md:p-16 p-8 rounded-lg bg-primaryDarkBg shadow-md justify-center max-lg:w-[65%] max-xl:w-[70%] max-sm:justify-start max-sm:w-[90%] max-md:w-[80%] max-md:justify-start z-50"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex items-center justify-center">
              <img
                className="object-cover rounded-lg w-40"
                src={Logo}
                alt="Damsel"
              />
            </div>
            <p className="py-6 text-2xl text-center max-sm:text-lg text-white font-bold">
              Hi, Welcome Back
            </p>
            {otpData?.message && (
              <div className="bg-opacity-50 flex items-center justify-center z-40">
                <div className="text-orange-400 rounded-lg shadow-md">
                  <p className="text-lg font-semibold">{otpData?.message}</p>
                </div>
              </div>
            )}
            <div className="mb-6 max-sm:mb-3">
              <input
                type="text"
                {...register("email")}
                name="email"
                id="email"
                className={`tracking-normal block max-sm:text-sm w-full px-4 py-2 max-sm:h-11 h-12 m-1 shadow-md text-base font-normal text-semi transition ease-in-out bg-transparent border border-solid rounded-lg form-control bg-clip-padding focus:text-semi focus:bg-primary3 focus:outline-none ${
                  errors.email
                    ? "is-invalid border-l-cancel border-cancel focus:border-cancel"
                    : " border-white"
                }`}
                placeholder="Email"
              />
              <div className="mt-1 ml-4 font-medium text-cancel">
                {errors.email?.message}
              </div>
            </div>
            <div className="relative mb-6 max-sm:mb-3">
              <input
                className={`block max-sm:text-sm w-full px-4 py-2 max-sm:h-11 h-12 m-1 shadow-md text-base font-normal text-semi transition ease-in-out bg-transparent border border-solid rounded-lg form-control bg-clip-padding focus:text-semi focus:bg-primary3 focus:outline-none ${
                  errors.password
                    ? "is-invalid border-l-cancel border-cancel focus:border-cancel"
                    : "border-white"
                }`}
                type={showPassword ? "text" : "password"}
                {...register("password")}
                placeholder="Password"
              />
              <span
                className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer"
                onClick={handleTogglePassword}
              >
                {showPassword ? "Hide" : "Show"}
              </span>
              <div className="mt-1 ml-4 font-medium text-cancel">
                {errors.password?.message}
              </div>
            </div>
            {/* {userData?.otpSended && (
              <div className="mb-6 max-sm:mb-3">
                <span className="text-white">
                  OTP sent to your email, Please verify!
                </span>
                <input
                  className={`block max-sm:text-sm w-full px-4 py-2 max-sm:h-11 h-12 m-1 shadow-md text-base font-normal text-semi transition ease-in-out bg-transparent border border-solid rounded-lg form-control bg-clip-padding focus:text-semi focus:bg-primary3 focus:outline-none`}
                  type="text"
                  // {...register("otp")}
                  placeholder="OTP"
                />
                <div className="mt-1 ml-4 font-medium text-cancel">
                  {errors.otp?.message}
                </div>
              </div>
            )} */}
            {/* <div className="flex items-center justify-end mb-6">
              <a
                href="/auth/forgot-password"
                className="hover:no-underline font-medium transition duration-200 ease-in-out text-white hover:text-blue-700 focus:text-primary1 active:text-primary1"
              >
                Forgot Password?
              </a>
            </div> */}

            <Button isLoading={isLoading.otpVerificationData} size="lg" type="submit">
              <div className="flex gap-1">
                {isLoading.otpVerificationData && (
                  <Oval
                    height={18}
                    width={18}
                    color="#ffff"
                    wrapperStyle={{}}
                    wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="gray-primary"
                    strokeWidth={6}
                    strokeWidthSecondary={6}
                  />
                )}
                <div className="font-normal text-base">Sign In</div>
              </div>
            </Button>

            <div id="errormsg" className="py-2 m-2 text-sm">
              <div>
                <p
                  className="text-cancel"
                  dangerouslySetInnerHTML={{ __html: errorMsg }}
                ></p>
              </div>
            </div>
          </form>
        ) : (
          <OtpVerification email={credentials?.email} password={credentials?.password} />
        )}
      </div>
    </motion.div>
  );
};

export default Login;
